import { createSlice } from "@reduxjs/toolkit"

export const merchantSlice = createSlice({
    name: "merchant",
    initialState: {
        merchantList: [],
        countryList: [],
        exportList: [],
        merchantDetail: {},
        isFreshData: false,
        totalEntry: 0,
        filterTerm: ''
    },   
    reducers: {
        setMerchantList: (state, action) => {
            state.merchantList = action.payload
        },
        setCountryList: (state, action) => {
            state.countryList = action.payload
        },
        setFreshList: (state, action) => {
            state.isFreshData = action.payload
        },
        setExportList: (state, action) => {
            state.exportList = action.payload
        },
        setFilterTerm: (state, action) => {
            state.filterTerm = action.payload
        },
        setTotalEntry: (state, action) => {
            state.totalEntry = action.payload
        },
        setSingleData: (state, action) => {
            state.merchantDetail = action.payload
        }
    }
})

export const {
    setMerchantList,
    setFreshList,
    setCountryList,
    setExportList,
    setFilterTerm,
    setSingleData,
    setTotalEntry,
    setFilteredList
} = merchantSlice.actions

export const selectMerchantList = (state) => state.merchant.merchantList
export const selectFreshData = (state) => state.merchant.isFreshData
export const selectCountryList = (state) => state.merchant.countryList
export const selectExportList = (state) => state.merchant.exportList
export const selectFilterTerm = (state) => state.merchant.filterTerm
export const selectTotalEntry = (state) => state.merchant.totalEntry
export const selectMerchantDetail = (state) => state.merchant.merchantDetail

export default merchantSlice.reducer
